import React, { useEffect, useState } from 'react';
import './ListView.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, Tag } from 'antd';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Listview = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { user } = useAuth();
  const username = user.user;
  const [tasks, setTasks] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [siteName, setSiteName] = useState('');
  const [siteAddress, setSiteAddress] = useState('');
  const [siteMobile, setSiteMobile] = useState('');
  const [siteEmail, setSiteEmail] = useState('');
  const [imageFile, setImageFile] = useState(null);

  const [formData, setFormData] = useState({

    taskDetails: '',
    assignee: '',
    priority: '',
    category: '',
    subCategory: '',
    status: '',
    deadline: '',
    clientName: '',
    siteName: '',
    siteAddress: '',
    siteMobile: '',
    siteEmail: '',
    assignedFrom: '',
    role: '',
    createdAt: '',
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'clientName') {
      const selectedClient = client.find(c => c.clientName === value);

      if (selectedClient) {
        setSiteName(selectedClient.siteName);
        setSiteAddress(selectedClient.siteAddress);
        setSiteMobile(selectedClient.siteMobile);
        setSiteEmail(selectedClient.siteEmail);
        setFormData((prevFormData) => ({
          ...prevFormData,
          siteName: selectedClient.siteName || '',
          siteAddress: selectedClient.siteAddress || '',
          siteMobile: selectedClient.siteMobile || '',
          siteEmail: selectedClient.siteEmail || '',
        }));
      }
    } else if (name === 'assignee') {
      const selectedUser = users.find(user => user.username === value);

      if (selectedUser) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          assignedFrom: username.username,
          role: selectedUser.role
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const currentDate = new Date();
    const updatedFormData = {
      ...formData,
      createdAt: currentDate.toISOString(), // Use toISOString() to get the date in a string format
    };
    fetch(API_URL + '/taskss', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => {
        console.error('Error sending form data:', error);
      });
  };

  const [users, setUsers] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/users')
      .then(response => response.json())
      .then(data => setUsers(data))
      .catch(error => console.error(error));
  }, []);

  const assigneeData = [];
  if (users) {
    users.forEach(i => {
      assigneeData.push(i.username);
    })
  }

  const [client, setClient] = useState([]);

  useEffect(() => {
    fetch(API_URL + '/client')
      .then(response => response.json())
      .then(data => setClient(data))
      .catch(error => console.error(error));
  }, []);

  const clientdata = [];
  if (client) {
    client.forEach(i => {
      clientdata.push(i.clientName);
    })
  }

  const deleteTask = async (uuId) => {
    try {
      const response = await axios.delete(API_URL + `/tasks/${uuId}`);

      if (response.status === 204) {
        console.log('Task deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting task');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTasksDetailsByName = (uuId) => {
    const filteredTasks = tasks.filter(task => task.uuId === uuId);
    navigate('/ListViewInfo', { state: { taskDetails: filteredTasks[0] } });
  };

  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue, selectedSort) => {
    selectedSort = selectedSort || '';
    let endpoint;

    if (!filterValue && !selectedSort) {
      if (username.role === 'Admin' || username.role === 'HR') {
        endpoint = API_URL + '/tasks/all';
      } else {
        endpoint = API_URL + `/tasks/?assignee=${username.username}`;
      }
    } else {
      if ((filterValue || selectedSort) && (username.role === 'Admin' || username.role === 'HR')) {
        endpoint = `${API_URL}/tasks/?assignee=&filter=${filterValue}&sort=${selectedSort}`;
      } else if (filterValue || selectedSort) {
        endpoint = `${API_URL}/tasks/?assignee=${username.username}&filter=${filterValue}&sort=${selectedSort}`;
      } else if (username.role === 'Admin' || username.role === 'HR') {
        endpoint = `${API_URL}/tasks/all`;
      } else {
        endpoint = `${API_URL}/tasks/?assignee=${username.username}&sort=${selectedSort}`;
      }
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };


  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setSiteName('');
    setSiteAddress('');
    setSiteMobile('');
    setSiteEmail('');
    setFormData({
      ...formData,
      taskDetails: '',
      clientName: '',
      assignee: '',
      priority: '',
      category: '',
      subCategory: '',
      status: '',
      deadline: '',
    });
    setImageFile(null);
  };

  const columns = [
    {
      title: 'Task',
      dataIndex: 'Task',
      key: 'Task',
      width: '8%',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Priority',
      dataIndex: 'Priority',
      key: 'Priority',
      render: (_, { Priority }) => (
        <>
          {Priority.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'High') {
              color = '#761F1F';
            }
            else if (tag === 'Medium') {
              color = '#215115';
            }
            else if (tag === 'Low') {
              color = '#A56D2B';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Status',
      key: 'Status',
      dataIndex: 'Status',
      render: (_, { Status }) => (
        <>
          {Status.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Pending') {
              color = '#761F1F';
            }
            else if (tag === 'Completed') {
              color = '#215115';
            }
            else if (tag === 'In-Process') {
              color = '#A56D2B'
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      render: (_, { Role }) => (
        <>
          {Role.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Admin') {
              color = '#173452';
            }
            else if (tag === 'HR') {
              color = '#173452';
            }
            else if (tag === 'Manager') {
              color = '#b5cce8';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Deadline',
      dataIndex: 'Deadline',
      key: 'Deadline',
      width: '11%',
    },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (_, record) => (
        <Space size="middle">
          <div onClick={() => getTasksDetailsByName(record.uuId)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteTask(record.uuId)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
        </Space>
      ),
    },
  ];
  const dataa = tasks.length > 0 ? tasks.map((item, index) => ({
    key: index.toString(),
    uuId: item.uuId,
    Task: index + 1,
    Name: item.assignee || '',
    Priority: [item.priority] || '',
    Status: [item.status || ''],
    Role: [item.role || ''],
    Deadline: item.deadline || '',
  })) : [];


  const inputStyle = {
    background: '#ECEAEA',
    border: 'none',
    padding: '5px',
    borderRadius: 5,
    outline: 'none',
    height: '25px',
    width: '60%',
  };
  const clearFilters = () => {
    setSearchInput('');
    setSelectedSort('');
    fetchTasks('', '');
  };


  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='tasks'>Tasks</h3>
          <Link to='/ListView' className='a_list_ListView' ><p className='list_ListView'>List</p></Link>
          <Link to='/CardVIew' className='a_card_ListView' ><p className='card_ListView'>Card</p></Link>
        </div>

        <div className='row3'>
          <div className='searchBox'>
            <div class="column1_searchBox">
              <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
            </div>

            <div class="column2_searchBox">
              <input className='search_input1' placeholder='Search' value={searchInput}
                onChange={(e) => {
                  const text = e.target.value;
                  setSearchInput(text);
                  fetchTasks(text, selectedSort);
                }}></input>
            </div>
          </div>
          <button className='add_task_btn' onClick={openForm}>+ Add task {/*<img className='plus' src="../assets/plus.png" alt="plus" height={"8px"}></img>*/}</button>

          <select className='sort_by_ListView' name='' value={selectedSort}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedSort(value);
              fetchTasks(searchInput, value);
            }}>
            <option value="" selected disabled hidden>Sort by</option>
            <option className='options'>Pending</option>
            <option className='options'>In-Process</option>
            <option className='options'>Complete</option>
          </select>
          <button className='clear_filter_btn' onClick={clearFilters}>Clear Filters</button>
        </div>
        {isFormOpen && (
          <>
            <div className="overlay_ListView" onClick={closeForm}></div>
            <div className="popup-form_ListView">
              <span className="close_ListView" onClick={closeForm}>&times;</span>
              <p className='addTask_popup_ListView'><b>Add Task</b></p>
              {/* Your form content goes here */}
              <form onSubmit={handleSubmit}>
                {/* Form fields go here */}
                <p>Add Task Detalis</p>
                <textarea className='task_details_input_ListView' placeholder='Enter Task Details Here...' name='taskDetails'
                  value={formData.taskDetails}
                  onChange={handleInputChange}></textarea>

                <div class="popup_row_ListView">
                  <div class="popup_column1_ListView">

                    <label>Name of the Assignee<br /><br />
                      <input list="Names" placeholder='Enter name of assignee' name="assignee" style={inputStyle} value={formData.assignee}
                        onChange={handleInputChange} />
                    </label>
                    <datalist id="Names" >
                      {assigneeData.map((assignee, index) => (
                        <option key={index} value={assignee} />
                      ))}
                    </datalist>

                    <div>

                      <p>Priority</p>
                      <select className='popup_form_select' name='priority'
                        value={formData.priority}
                        onChange={handleInputChange}>
                        <option value="" selected disabled hidden>Select</option>
                        <option className='options'>High</option>
                        <option className='options'>Medium</option>
                        <option className='options'>Low</option>
                      </select>

                    </div>

                    <p>Category</p>
                    <select className='popup_form_select' name='category'
                      value={formData.category}
                      onChange={handleInputChange}>
                      <option value="" selected disabled hidden>Select</option>
                      <option className='options'>Service</option>
                      <option className='options'>Installation</option>
                      <option className='options'>Site Visit</option>
                    </select>

                    <p>Sub Category</p>
                    <select className='popup_form_select' name='subCategory'
                      value={formData.subCategory}
                      onChange={handleInputChange}>
                      <option value="" selected disabled hidden>Select</option>
                      <option className='options'>POP</option>
                      <option className='options'>Furniture</option>
                      <option className='options'>Lights</option>
                    </select>

                    <p>Status</p>
                    <select className='popup_form_select' name='status'
                      value={formData.status}
                      onChange={handleInputChange}>
                      <option value="" selected disabled hidden>Select</option>
                      <option className='options'>Pending</option>
                      <option className='options'>In-Process</option>
                      <option className='options'>Completed</option>
                    </select>

                    <p>Deadline</p>
                    <input type="date" id="date" name="deadline" className='popup_form_deadline' value={formData.deadline}
                      onChange={handleInputChange} />

                    <p>Upload Document</p>
                    <input type="file" accept="image/*" onChange={(e) => handleImageChange(e)} />
                    {imageFile && (
                <img
                  src={URL.createObjectURL(imageFile)}
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }}
                />
              )}                  </div>

                  <div class="popup_column2_ListView">

                    <label>Name of the Client<br /><br />
                      <input list="ClientNames" placeholder='Enter name of client' name="clientName" style={inputStyle} value={formData.clientName}
                        onChange={handleInputChange} />
                    </label>
                    <datalist id="ClientNames" >
                      {clientdata.map((client, index) => (
                        <option key={index} value={client} />
                      ))}

                    </datalist>

                    <p>Site Name </p>
                    <div className='label_popup_ListView'>
                      <label>{siteName}</label>
                    </div>

                    <p>Phone No. </p>
                    <div className='label_popup_ListView'>
                      <label>{siteMobile}</label>
                    </div>

                    <p>Email ID </p>
                    <div className='label_popup_ListView'>
                      <label>{siteEmail}</label>
                    </div>

                    <p>Address </p>
                    <div className='label_popup_ListView'>
                      <label>{siteAddress}</label>
                    </div><br />
                  </div>

                </div>
                <button type="submit" value="Submit" className='popup_form_addTask_ListView' >Add Task</button>
                <button type="submit" value="close" onClick={closeForm} className='popup_form_cancel_ListView'>Cancel</button>

              </form>
            </div>
          </>
        )}

        <div className='row4'>
          <h5>All Tasks</h5>
        </div>

        <div className='table_ListView'>
          <Table
            columns={columns}
            dataSource={dataa}
            scroll={{ y: 420 }}
            pagination={false}
          />
        </div>

        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

      </div>

    </div>
  )
}

export default Listview;